import { TAppState } from '../types/appState';

export const parentSourceSelector = (state: TAppState) => state.parentSource;
